import { makeAutoObservable, runInAction } from "mobx";
import { RootStore } from "./rootStore";
import agent from "../api/agent";
import { IContentTreePageDto } from "../models/archive";
import { INodeGeneric } from "../models/node";
import { PlayerBrowsePageDto } from "../models/dto";

export default class ArchiveStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
      this.rootStore = rootStore;
      makeAutoObservable(this);
    }
    currentTree: IContentTreePageDto | null = null;
    archivesArray: INodeGeneric[] = [];
    loadingArchives: boolean = true;
    autoOpeningFolder: boolean | undefined = undefined;

    setAutoOpeningFolder = (value? : boolean) => {
      this.autoOpeningFolder = value;
    }

    loadNodes = async (archiveId: number, languageId?: number) => {
        try {
          const archiveContentsTree : IContentTreePageDto = await agent.Archive.GetArchiveContents(archiveId);
          runInAction(() => {
            this.currentTree = archiveContentsTree;
            console.log("autoOpeningFolder: ", this.autoOpeningFolder);
            if(this.autoOpeningFolder === undefined)
              this.autoOpeningFolder = archiveContentsTree.autoOpeningFolder;
            // this.contentFoldersArray = this.treeDeepLevelNodeList(archiveContentsTree.tree);
          });
          return archiveContentsTree;
        } catch (error) {
          console.log(error);
          throw error;
        }
    };

    resetNodeTree = () => {
        this.currentTree = null;
    };

    GetArchiveBrowsePageDetails = async (archiveId: number,contentId: number) => {
      try {
        const dto : PlayerBrowsePageDto = await agent.Archive.GetArchiveBrowsePageDetails(archiveId,contentId);
        runInAction(() => {
          this.rootStore.commonStore.setArchiveBrowsePageDetails(dto);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    };

    loadArchives = async () => {
        this.loadingArchives = true;
        try {
          const archives = await agent.Archive.list();
          runInAction(() => {
            this.archivesArray = archives;
            this.loadingArchives = false;
          });
        } catch (error) {
          runInAction(() => {
            this.loadingArchives = false;
          });
        }
      };
}